import { Download, Plus } from "../assets/icons";

export const OPERATION_TYPE_CHOICES = [
  { id: "inspection", name: "Inspection" },
  { id: "setup", name: "Setup" },
  { id: "manufacturing", name: "Manufacturing" },
  { id: "quality_control", name: "Quality Control" },
  { id: "pack", name: "Pack" },
  { id: "run", name: "Run" },
  { id: "other", name: "Other" },
];

export const roles = [
  {
    value: "Admin",
    label: "Admin",
    description: "Possesses complete access and can onboard members, users, and trackers.",
  },
  {
    value: "Editor",
    label: "Editor",
    description:
      "Part of the main organization with the power to alter related orders or shipments",
  },
  {
    value: "Member",
    label: "Member",
    description:
      "Can view content and suggest modifications. They have the authority to add viewers or editors, but any modifications require approval from a member or admin.",
  },
  {
    value: "Viewer",
    label: "Viewer",
    description: "Only allowed to see and share content shared with them",
  },
];

export const MODULE_COLUMNS = {
  product: [
    "NUMBER",
    "NAME",
    "TYPE",
    "CATEGORIES",
    "TAGS",
    "TAX CLASSIFICATION",
    "TRACKING METHOD",
    "BRAND",
    "SHORT DESCRIPTION",
    "LONG DESCRIPTION",
    "BARCODE",
    "UOM",
    "CBM",
    "HEIGHT",
    "LENGTH",
    "WIDTH",
    "DIMENSION UOM",
    "WEIGHT",
    "WEIGHT UOM",
    "CREATED BY",
    "CREATE DATE",
    "STATUS",
  ],
};

export const COST_ALLOCATION_METHOD = [
  { id: "value", name: "Standard" },
  { id: "volume", name: "Volume" },
  { id: "volumetric_weight", name: "Volumetric Weight" },
  { id: "weight", name: "Weight" },
];

export const PURCHASE_ORDER_PRIORITY = [
  { id: 0, name: "Standard" },
  { id: 1, name: "Medium" },
  { id: 2, name: "High" },
  { id: 3, name: "Critical" },
];
export const DELIVERY_PRIORITY_CHOICES = [
  { id: "standard", name: "Standard" },
  { id: "medium", name: "Medium" },
  { id: "high", name: "High" },
  { id: "critical", name: "Critical" },
];
export const BANK_ACCOUNT_CHOICES = [
  { id: "in_cash", name: "In Cash" },
  { id: "bank_account_one", name: "Bank Account One" },
];
export const ALLOCATED_COST_TO_CHOICES = [
  { id: `purchase_order`, name: "Purchase Order" },
  { id: `consignment`, name: "Shipment" },
  { id: `receipt`, name: "Receipt" },
];
export const TRACKING_METHOD_CHOICES = [
  { id: "none", name: "None" },
  { id: "serial", name: "Serial" },
  { id: "batch", name: "Batch" },
  { id: "batch_and_serial", name: "Serial & Batch" },
];
export const MONTHLY_CHOICES = [
  { id: 1, name: "January" },
  { id: 2, name: "February" },
  { id: 3, name: "March" },
  { id: 4, name: "April" },
  { id: 5, name: "May" },
  { id: 6, name: "June" },
  { id: 7, name: "July" },
  { id: 8, name: "August" },
  { id: 9, name: "September" },
  { id: 10, name: "October" },
  { id: 11, name: "November" },
  { id: 12, name: "December" },
];

export const UOM_CATEGORY_CHOICES = [
  { id: "count", name: "Count" },
  { id: "weight", name: "Weight" },
  { id: "volume", name: "Volume" },
  { id: "length", name: "Length" },
  { id: "area", name: "Area" },
  { id: "time", name: "Time" },
];

export const MANAGE_STEPS = {
  product: [
    {
      title: "Base Details",
      desc: "Step 1",
      fields: {
        Name: "The name of the product.",
        Number: "The product's unique identifier.",
        "Short Description": "A brief summary describing the product.",
        Categories: "User-defined classification that groups similar products.",
        "Product Type": "The product's classification (e.g., finished goods, raw materials).",
        Status: "Operations status of the product.",
        "Product Tax Classification":
          "A grouping used to categorise products based on how they are treated for tax purposes.",
        UOM: "The product's standard unit of measure.",
      },
    },
    {
      title: "More Details",
      desc: "Step 2",
      fields: {
        "Long Description": "Extended product details and specifications.",
        Length: "The product's length.",
        Width: "The product’s width.",
        Height: "The product’s height.",
        "Dimension UOM": "Unit of measure applied to length, width and height.",
        Weight: "The product’s mass.",
        "Weight Units": "Unit of measure for weight.",
        CBM: "Product volume expressed in cubic metres",
      },
    },
    {
      title: "Advance Details",
      desc: "Step 3",
      fields: {
        Barcode: "The product’s barcode value used for scanning.",
        Brand: "The brand associated with the product.",
        Tags: "Keywords or labels linked to the product",
        "Radio Frequency": "Used for barcode scanning compatibility",
        "Tracking Method":
          "Determines whether the product is tracked in inventory using batch numbers, serial numbers, or both.",
        "Harmonized System (HS) Code": "Customs classification code for international trade.",
        Warranty: "Warranty terms or coverage details for the product.",
      },
    },
  ],
  productCategory: [
    {
      title: "Base Details",
      desc: "Step 1",
      fields: {
        Name: "The name of the product category.",
        "Short Description": "A brief summary describing the category.",
        "Long Description":
          "Extended details about the category, including its purpose, usage, or specifications.",
        "Parent Category":
          "The higher-level category that this category belongs to, if applicable.",
        "Category Status": "Indicates whether the category is active or inactive.",
      },
    },
  ],
  productTag: [
    {
      title: "Base Details",
      desc: "Step 1",
      fields: {
        Name: "The name of the product tag.",
        "Short Description": "A brief summary describing the tag.",
        "Tag Status": "Indicates whether the tag is active or inactive.",
      },
    },
  ],
  customerTag: [
    {
      title: "Base Details",
      desc: "Step 1",
      fields: {
        Name: "The name of the customer tag.",
        "Short Description": "A brief summary describing the tag.",
        "Tag Status": "Indicates whether the tag is active or inactive.",
      },
    },
  ],
  customerSegment: [
    {
      title: "Base Details",
      desc: "Step 1",
      fields: {
        Name: "The name of the customer segment.",
        Countries: "The countries that belong to this customer segment.",
        States: "The states that belong to this customer segment.",
        Cities: "The cities that belong to this customer segment.",
        "Post Codes": "The post codes that belong to this customer segment.",
        Status: "Indicates whether the customer segment is active or inactive.",
        "Customer Types": "The customer types that belong to this customer segment.",
        "Customer Sub-types": "The customer sub-types that belong to this customer segment.",
        "Customer Statuses": "The customer statuses that belong to this customer segment.",
        "Customer Payment Terms":
          "The customer payment terms that belong to this customer segment.",
        "Customer Tags": "The customer tags that belong to this customer segment.",
      },
    },
  ],
  productPlan: [
    {
      title: "Base Details",
      desc: "Step 1",
      fields: {
        Product: "The product SKU that this planning configuration applies to.",
        "Acquisition Code":
          "Defines how this product is replenished — either Purchased from an external supplier or Transferred from another facility.",
        "Supplier / From Facility":
          "The source of the product based on the Acquisition Code (Supplier for Purchase, From Facility for Transfer).",
        "To Facility":
          "The destination facility where this planning setup applies and stock will be stored.",
      },
    },

    {
      title: "Planning",
      desc: "Step 2",
      fields: {
        "Planning Policy":
          "The inventory planning strategy — Safety Stock buffer, Reorder Point (ROP) based, or Zero Stock.",
        "Safety Stock Method":
          "Calculation method for safety stock — Fixed Quantity in units or Days of Cover.",
        "Safety Stock Qty":
          "Fixed safety stock buffer quantity in units to protect against demand variability.",
        "Safety Stock Days": "Safety stock buffer expressed as number of days of demand coverage.",
        "Re-Order Plan Method":
          "Calculation method for reorder point — Fixed Quantity in units or Days of Cover.",
        "Re-Order Plan Qty":
          "Fixed reorder point quantity in units. Triggers replenishment when stock falls to this level.",
        "Re-Order Plan Days":
          "Reorder point threshold expressed as number of days of demand coverage.",
      },
    },
    {
      title: "Lead Times",
      desc: "Step 3",
      fields: {
        "Production Lead Time Days":
          "The time required to produce or manufacture the product before shipment or availability.",
        "Transit Lead Time Days":
          "The time the product spends in transit before arriving at the destination.",
        "Total Lead Time Days":
          "Total end-to-end lead time in days, automatically calculated as Production Lead Time Days + Transit Lead Time Days.",
        "Ageing Days":
          "The number of days stock must wait before becoming sellable, such as curing for manufactured items, inspection for purchased items, or testing for co-manufactured items.",
      },
    },
    {
      title: "Other Details",
      desc: "Step 4",
      fields: {
        "Min Order Qty":
          "The smallest quantity that can be ordered in a single replenishment order.",
        "Order Multiple":
          "The required incremental quantity step that orders must adhere to (e.g., must order in multiples of 10).",
        "Plan Horizon Days":
          "Number of days into the future to consider when generating orders and planning demand (default: 365 days).",
        "Default Location":
          "The primary storage location within the destination facility where stock is received and stored.",
        "Pick Location is same as Default Location":
          "When enabled, the default location is used as the pick location and internal replenishment is not required.",
        "Pick Location":
          "Location where stock is stored and reserved for sales or outbound fulfillment.",
        "Replenishment Calculation Method":
          "Method used to calculate replenishment quantities (e.g., Upto Max Stock or Manual).",
        "Maximum Pick Location Stock":
          "Maximum stock capacity allowed in the pick location. Must be ≥ Trigger Qty.",
        "Trigger Qty":
          "Threshold stock quantity in pick location that triggers internal replenishment from default location.",
        "Replenishment Qty":
          "Fixed quantity used to refill pick location from default location when calculation method is set to Manual (capped at Maximum Pick Location Stock).",
        "Product Plan Status":
          "Controls whether this planning configuration is active or inactive.",
        "Primary Planning Configuration":
          "Designates this plan as the primary default planning configuration for this Product and Destination Facility.",
      },
    },
  ],
  productAlias: [
    {
      title: "Base Details",
      desc: "Step 1",
      fields: {
        "Master Product": "The master product that this alias is linked to.",
        "Alias Name": "The descriptive name or label for the alias.",
        "Alias Number": "The unique code or identifier assigned to the alias.",
        Facility: "The facility where this alias is set up or used.",
        Supplier: "The supplier associated with this alias.",
      },
    },
  ],
  warehouse: [
    {
      title: "Base Details",
      desc: "Step 1",
      fields: {
        "Facility Name": "The display name of the facility.",
        "Facility Code":
          "The unique code or abbreviated identifier for the facility. Must be unique within your company.",
        "Facility Type":
          "Select one or more facility types that describe this facility (for example Distribution Center, Factory / Manufacturing Plant, Fulfillment Center, Cross-Dock, Sales / Retail Hub, 3PL, 3PM, or Facility). Multi-purpose sites can combine several types. Selecting 3PL or 3PM requires linking an external Partner.",
        Partner:
          "Required for 3PL and 3PM facilities. Links the facility to an external supplier. For 3PL and 3PM facilities, the partner must be flagged as a co-manufacturer.",
        Site: "Required. The parent site this facility belongs to in the Company → Site → Facility hierarchy.",
        Country:
          "The country where the facility is located. Address search is limited to this country.",
        "Short Description": "A brief summary describing the facility.",
        Address:
          "Search and select a verified address in the selected country, or enter your address manually if it cannot be found. The address country must match the facility country.",
      },
    },

    {
      title: "More Details",
      desc: "Step 2",
      fields: {
        "Long Description":
          "Extended details about the facility, including its purpose, operations, or specifications.",
      },
    },

    {
      title: "Advance Details",
      desc: "Step 3",
      fields: {
        "Transit Air Days":
          "Average transit time in days for inbound or outbound shipments sent by air.",
        "Transit Ocean Days":
          "Average transit time in days for inbound or outbound shipments sent by ocean.",
      },
    },
  ],

  supplier: [
    {
      title: "Base Details",
      desc: "Step 1",
      fields: {
        Name: "The name of the supplier.",
        Code: "The unique code or abbreviated identifier for the supplier.",
        Currency: "The currency used by the supplier.",
        Address: "The physical address of the supplier.",
      },
    },
    {
      title: "More Details",
      desc: "Step 2",
      fields: {
        Email: "The supplier’s primary email address.",
        Contact: "The main contact person at the supplier.",
        "Default Payment Term":
          "Select the payment terms that will be applied by default to purchase orders created for this supplier.",
        "Co Manufacturer": "Indicates whether the supplier is a co-manufacturer.",
        "Supplier Status": "Indicates whether the supplier is active or inactive.",
      },
    },
    {
      title: "Advance Details",
      desc: "Step 3",
      fields: {
        Notes: "Additional information or comments about the supplier.",
      },
    },
  ],

  pack: [
    {
      title: "Pack Details",
      desc: "Step 1",
      fields: {
        Product: "The product that this pack configuration is created for.",
        UOM: "The unit of measure used for the pack.",
        "Quantity Per Pack":
          "The number of individual units contained within one pack (e.g., 100 cartons per pack).",
        Scope:
          "Select one or more options to indicate the modules in which this pack is applicable, such as Sales, Purchase, Inventory, or Production. Multiple selections are allowed.",
      },
    },
    {
      title: "Sourcing & Movement",
      desc: "Step 2",
      fields: {
        Supplier:
          "The external supplier used when sourcing the product within this pack. (Select this or From Facility.)",
        "From Facility":
          "The internal facility used when sourcing the product within this pack. (Select this or Supplier.)",
        "To Facility": "The facility where the pack will be received or stored.",
      },
    },
    {
      title: "Measurements",
      desc: "Step 3",
      fields: {
        Weight: "The total weight of the pack",
        "Weight Units": "The unit of measure used for the pack weight",
        Length: "The length of the pack",
        Width: "The width of the pack",
        Height: "The height of the pack",
        "Dimension Units":
          "The unit of measure used for the pack dimensions (length, width, and height).",
      },
    },
  ],
  forecast: [
    {
      title: "Base Details",
      desc: "Step 1",
      fields: {
        Product: "The product that the forecast applies to.",
        Facility: "The facility for which the forecast is created.",
        "From Date": "The start date of the forecast period.",
        "To Date": "The end date of the forecast period.",
        Quantity: "The amount of product projected to be sold or used within the forecast period.",
      },
    },
  ],
  warehouseCosting: [
    {
      title: "Base Details",
      desc: "Step 1",
      fields: {
        Product: "The product that the costing rule applies to.",
        Supplier: "The supplier the product comes from before arriving at the To Facility.",
        "From Facility":
          "The facility where the product is sent from before arriving at the To Facility.",
        "To Facility": "The facility where the product arrives and the costing rule applies.",
        "Min Quantity (From)":
          "The starting quantity for this price tier. Ranges run from this quantity up to the next tier.",
        "Unit Price": "The unit purchase price that applies from this tier's starting quantity.",
      },
    },
  ],
  stockZone: [
    {
      title: "Base Details",
      desc: "Step 1",
      fields: {
        Name: "The name of the stock zone.",
        Type: "The functional type of this zone (for example Bulk, Pick Face, Staging, Quarantine, or Production Floor). Choose a preset, or select Other to enter a custom type for your company.",
        Facility: "The facility this stock zone belongs to.",
        "Stock Zone Status": "Indicates whether the stock zone is active or inactive.",
      },
    },
  ],
  stockLocation: [
    {
      title: "Base Details",
      desc: "Step 1",
      fields: {
        Code: "The unique code used to identify the stock location.",
        Name: "The name of the stock location.",
        "Stock Zone": "The zone this stock location falls under.",
        "Stock Location Status": "Indicates whether the stock zone is active or inactive.",
      },
    },
  ],
  transactionReason: [
    {
      title: "Base Details",
      desc: "Step 1",
      fields: {
        Reason: "The name of the stock adjustment reason.",
        Code: "The abbreviated code used to identify this reason.",
        Impact:
          "Specifies how this adjustment affects inventory — whether it adjusts quantity, value, or both, and whether it increases or decreases the amount.",
      },
    },
  ],
  standardCost: [
    {
      title: "Base Details",
      desc: "Step 1",
      fields: {
        Facility: "The facility where this standard cost will be applied.",
        Product: "The product this standard cost applies to.",
        "Standard cost":
          "The default cost used to value inventory for this product at the selected facility when there is no average cost available.",
        "Other Costs type":
          "Choose whether other costs are a fixed amount or a percentage of the standard cost.",
        "Other Costs":
          "Additional costs involved in getting the selected product to the selected facility, e.g., freight costs, customs costs.",
      },
    },
  ],
  chartsOfAccount: [
    {
      title: "Chart of Accounts",
      desc: "Step 1",
      fields: {
        Name: "The display name of the account shown throughout Orderlink.",
        Code: "The unique account code used to identify the account.",
        "Account Type":
          "Determines how the account behaves and how transactions are recorded against it.",
        Currency: "The currency that the account operates in.",
        Description: "Additional details about the purpose of the account.",
        "Allow direct payments to this account":
          "Determines whether a payment can be recorded directly to this account without a bill or invoice.",
        "Show in expense claims":
          "Determines whether this account can be selected when coding an expense claim.",
      },
    },
  ],
  stockLine: [
    {
      title: "Base Details",
      desc: "Step 1",
      fields: {
        Product: "The product the initial record applies to.",
        Facility: "The facility where the product is held.",
        UOM: "The unit of measure for the product quantity.",
        "Stock Location": "The location within the facility where the product is stored.",
      },
    },
    {
      title: "Availability",
      desc: "Step 2",
      fields: {
        Quantity: "The amount of product recorded during the initial setup.",
        Status: "The operational status of the product (e.g., sellable or unsellable).",
        "Is Allocatable": "Indicates whether this quantity can be allocated to orders.",
      },
    },
    {
      title: "Value",
      desc: "Step 3",
      fields: {
        "Unit Cost": "The per-unit cost of the product at the time of setup.",
        "Other Costs":
          "The other costs per unit including all related expenses such as shipping and duties.",
      },
    },
  ],
  paymentTerm: [
    {
      title: "Payment Term",
      desc: "Step 1",
      fields: {
        Name: "A clear recognizable name for this payment term. This name is shown when selecting payment terms on customers, suppliers, and documents.",
        Type: "Chose how the due date is calculated from the document date.",
        "Due Days":
          "Enter the number of days used to calculate the due date based on the selected payment type. The meaning of this value depends on the payment term type you chose.",
        "Month Offset": "Enter the number of months to offset the due date.",
        Description: "Additional details about the payment term for internal reference.",
        Status: "Indicates whether the payment term is active or inactive.",
      },
    },
  ],
  billChargeType: [
    {
      title: "Bill Charge Type",
      desc: "Step 1",
      fields: {
        Name: "A clear recognizable name for this bill charge type (e.g., Freight, Handling, Insurance).",
        "Unit Price": "The default unit price for this charge.",
        "Amount Type":
          "Specifies whether this charge is Exclusive of tax, Inclusive of tax, or No Tax.",
        "Distribution Type":
          "The cost allocation basis across items (Standard, Weight, Volume, Volumetric Weight).",
        "Is Landed Cost":
          "Indicates if this charge is capitalized into inventory valuation or treated as an expense.",
        Description: "Optional additional notes or description for internal reference.",
      },
    },
  ],
  site: [
    {
      title: "Site Details",
      desc: "Step 1",
      fields: {
        Code: "The site's unique identifier code.",
        Name: "The name of the site.",
        "Time Zone": "The timezone the site operates in.",
        "Physical Address": "The physical address of the site.",
        "Site Status": "Indicates whether the site is active or inactive.",
      },
    },
  ],
  workCenter: [
    {
      title: "Work Centre",
      desc: "Step 1",
      fields: {
        Site: "Select the site this work centre belongs to.",
        Facility: "Select the facility this work centre belongs to.",
        Zone: "Select the zone this work centre belongs to.",
        Location: "Select the location this work centre belongs to.",
        Code: "The unique code or abbreviated identifier for the work centre.",
        Name: "Enter the name of this work centre.",
        Description: "Enter a description for this work centre.",
        Type: "Select the type of work centre.",
        Status: "Indicates whether the work centre is active or inactive.",
      },
    },
  ],
  people: [
    {
      title: "People",
      desc: "Step 1",
      fields: {
        "First Name": "Enter the person's first name.",
        "Last Name": "Enter the person's last name.",
        Role: "Select the production role.",
        "Email Address": "Enter the person's email address.",
        Phone: "Enter the person's phone number.",
        Status: "Indicates whether the person is active or inactive.",
      },
    },
  ],
  taxRate: [
    {
      title: "Tax Rate",
      desc: "Step 1",
      fields: {
        "Tax Category": "Used to identify the tax category applied to a product or transaction.",
        Jurisdiction:
          "The legal authority (such as a country, state, or province) that governs the application of this tax rate.",
        Name: "The name of the tax rate.",
        Rate: "The percentage rate at which the tax is applied to taxable goods or services within the specified jurisdiction.",
      },
    },
  ],
  customer: [
    {
      title: "Customer Overview",
      desc: "Step 1",
      fields: {
        "Customer Type": "Determines whether the customer is a business or an individual.",
        "Display Name":
          "The name displayed for the customer on sales orders, invoices, and other documents.",
        "Legal Name":
          "The registered legal name of the customer used for official and financial documents.",
        "Company ID":
          "The legal business identifier for the customer, such as NZBN (New Zealand Business Number) or ABN (Australian Business Number).",
        "GST Number": "The customer's GST or tax registration number used for tax reporting.",
        "Customer Code":
          "A short unique identifier for the customer, displayed across all transactions.",
        "Customer Status":
          "Determines the current state of the customer and whether they can be used on transactions.",
        "Customer Sub-Type":
          "Defines the customer’s business classification, such as Retail, Wholesale, or Distributor.",
        Tag: "Used for filtering, segmentation, reporting, and applying rules across the system",
        Email: "The primary email address for the customer.",
        "Phone Number": "The primary contact number for the customer.",
      },
    },

    {
      title: "Contacts",
      desc: "Step 2",
      fields: {
        "Contact Persons":
          "Additional contacts associated with the customer for communication. The first contact in the list is the primary contact.",
      },
    },
    {
      title: "Addresses",
      desc: "Step 3",
      fields: {
        "Shipping Address": "The address where goods are shipped to.",
        "Billing Address": "The address where invoices and financial documents are sent.",
      },
    },
    {
      title: "Operations",
      desc: "Step 4",
      fields: {
        "Sales Rep": "The default sales person assigned to this customer.",
        "Default Carrier": "The carrier used to deliver goods to the customer.",
      },
    },
    {
      title: "Financial",
      desc: "Step 5",
      fields: {
        "Account Number": "The bank account number used to make payments to the customer.",
        Currency: "The currency used for the customer's transactions.",
        "Default Tax Rate": "The tax treatment applied to the customer's transactions.",
        "Credit Limit Amount": "The maximum credit amount allowed for the customer.",
        "Default Payment Term": "The payment terms applied to the customer's invoices.",
        "Default Sale Account": "The revenue account used for the customer's sales transactions.",
        "Credit Hold": "Prevents the customer from being used on new sales transactions.",
      },
    },
  ],
  taxCategory: [
    {
      title: "Tax Category",
      desc: "Step 1",
      fields: {
        "Tax Category Name":
          "The name used to identify the tax category applied to a product or transaction.",
        "Tax Category Description": "Detailed description of the tax category.",
      },
    },
  ],
  productTaxClassification: [
    {
      title: "Product Tax Classification",
      desc: "Step 1",
      fields: {
        "Product Tax Classification":
          "A grouping used to categorise products based on how they are treated for tax purposes.",
        Description: "Detailed description of the product tax classification.",
      },
    },
  ],
  unitOfMeasure: [
    {
      title: "Unit of Measure",
      desc: "Step 1",
      fields: {
        Name: "The full name of the unit of measure.",
        Code: "A short unique identifier for the unit of measure used across products and transactions.",
        Category:
          "Groups units of measure by type, such as count, length, area, or volume. Used to ensure only compatible units are used together.",
      },
    },
  ],
  salesRep: [
    {
      title: "Sales Rep",
      desc: "Step 1",
      fields: {
        "Linked User":
          "Select an existing user to link this salesperson to. This will auto-fill their name and email.",
        "Rep Name":
          "Enter the name of the sales rep. This will be displayed on sales orders and used for reporting.",
        Email:
          "Enter the salesperson’s email address. This is used for reference and can be included on documents if needed. The email address where the invitation will be sent.",
        "Rep Status": "Indicates whether the sales rep is active or inactive.",
      },
    },
  ],
  equipmentType: [
    {
      title: "Equipment Type",
      desc: "Step 1",
      fields: {
        Name: "The name of the equipment type.",
        Code: "A short unique identifier for the equipment type.",
        Category: "The category the equipment type belongs to.",
      },
    },
  ],
  equipment: [
    {
      title: "Equipment",
      desc: "Step 1",
      fields: {
        "Equipment Type": "The category and characteristics of the equipment.",
        Number:
          "A unique identifier for this equipment, such as a container number, vehicle registration, trailer number, or asset ID.",
        "Equipment Status": "Indicates whether the equipment is active or inactive.",
      },
    },
  ],
};

export const INTEGRATIONS_MANAGE_STEPS = {
  inventoryPlanner: [
    {
      title: "Authenticate",
      desc: "Step 1",
    },
    {
      title: "Facility Mapping",
      desc: "Step 2",
      fields: {
        "Match Facility Names":
          "Match each facility in Orderlink to the corresponding facility in Inventory Planner. /n If you do not want to map the facility, select the option from dropdown “Do Not Map”.",
      },
    },
    {
      title: "Facility Operations",
      desc: "Step 3",
      fields: {
        "Match Facility Names":
          "Match each facility in Orderlink to the corresponding facility in Inventory Planner. /n If you do not want to map the facility, select the option from dropdown “Do Not Map”.",
      },
    },
    {
      title: "Synchronization",
      desc: "Step 4",
      fields: {
        "Match Facility Names":
          "Match each facility in Orderlink to the corresponding facility in Inventory Planner. /n If you do not want to map the facility, select the option from dropdown “Do Not Map”.",
      },
    },
  ],

  b2b: [
    {
      title: "Portal Details",
      desc: "Step 1",
      fields: {
        "Portal Subdomain": "This is the web address customers will use to access your B2B portal.",
        "Portal Email":
          "This email address is used for portal communications including order confirmations, shipment updates, and return notifications.",
        "Account ID":
          "This is the unique identifier for your portal within Orderlink. It is used to link portal activity back to your organisation.",
        "Authorization Key":
          "This key is used to securely connect your B2B portal to Orderlink. It is required for authentication and should be kept secure. If needed, a new key can be generated which will replace the existing one.",
      },
    },
    {
      title: "Configuration",
      desc: "Step 2",
      fields: {
        "Order Submission Status":
          "Determines whether orders submitted from the B2B portal are created in Orderlink as Draft or Confirmed sales orders.",
        "Default Tax Rate":
          "This is the tax rate applied to portal orders when no customer-specific tax settings are available. It is used to calculate and display tax on portal pricing.",
        "Include Assembled Products":
          "When enabled, assembled products will be included in the product catalogue available in the B2B portal. When disabled, assembled products will be excluded.",
        "Stock Availability Facilities":
          "Uses selected facilities to calculate stock shown in the portal.",
      },
    },
    {
      title: "Customer Access",
      desc: "Step 3",
      fields: {
        "Customer Access":
          "Select which customers will have access to the B2B portal. Use filters to search by customer code, name, or segment, then tick the checkbox next to each customer to include them.",
      },
    },
    {
      title: "Product Visibility",
      desc: "Step 4",
      fields: {
        "Product Visibility":
          "Select which products will be visible in the B2B portal. Use filters to search by product number, name, or category, then tick the checkbox next to each product to make them visible.",
      },
    },
  ],
  xero: [
    {
      title: "Connect",
      desc: "Step 1",
      fields: {},
    },
    {
      title: "Account Mapping",
      desc: "Step 2",
      fields: {
        "Xero Account": (
          <div>
            Orderlink uses internal accounts to create accounting journals. Before syncing
            transactions to Xero, you need to map each Orderlink account to a Xero chart of account.
            <br />
            <br />
            For each Orderlink account, select the Xero account it should post to. Xero accounts are
            synced automatically and are read-only in Orderlink. If the required account does not
            exist in Xero, you’ll need to create it in Xero first before it can be mapped.
            <br />
            <br />
            All required accounts must be mapped before a sync can run. If any required mapping is
            missing, transactions will not be sent to Xero.
          </div>
        ),
      },
    },
    {
      title: "Tax Mapping",
      desc: "Step 3",
      fields: {
        "Xero Tax": (
          <div>
            Orderlink uses internal tax rates to calculate tax on transactions. Before syncing
            transactions to Xero, you need to map each Orderlink tax to a Xero tax rate.
            <br />
            <br />
            For each Orderlink tax, select the Xero tax rate it should use. Xero tax rates are
            synced automatically and are read-only in Orderlink. If the required tax rate does not
            exist in Xero, you’ll need to create it in Xero first before it can be mapped.
            <br />
            <br />
            All required taxes must be mapped before a sync can run. If any required mapping is
            missing, transactions will not be sent to Xero.
          </div>
        ),
      },
    },
    // Settings (old Step 4) was never implemented — only a blank screen. Sync is the real
    // configuration step after tax mapping.
    {
      title: "Synchronization",
      desc: "Step 4",
      fields: {
        "Manual Sync":
          "Choose manual sync if you prefer to control when data is sent to Xero. Automation sync options will be turned off.",
        "Start Date":
          "Select the date from which Orderlink will begin syncing data with Xero. Transactions before this date will not be synced.",
        "Time Zone": "Select the time zone used to schedule automatic syncs.",
        "Start Time":
          "Choose the time of day when automatic syncing will begin. Syncs will run from this time based on the selected frequency.",
        "Sync Frequency": "Choose how often Orderlink automatically syncs data with Xero.",
      },
    },
  ],
  shopify: [
    {
      id: "connect",
      title: "Connect Store",
      desc: "Step 1",
      fields: {
        "Why connect": (
          <div>
            Connecting your Shopify store authorises Orderlink to exchange orders, products,
            inventory, and fulfilment data securely with Shopify.
            <br />
            <br />
            Complete this step first. Without an authenticated connection, settings and mapping
            steps cannot run, and no store data will sync.
          </div>
        ),
        "What this step shows":
          "If the store is already connected, you will see the linked shop name and domain. You can disconnect here if you need to stop syncing and reconnect later.",
      },
    },
    {
      id: "settings",
      title: "Settings",
      desc: "Step 2",
      fields: {
        "Why configure settings": (
          <div>
            These settings control how Shopify orders become sales orders in Orderlink, how products
            and pricing are treated, and how fulfilment and invoicing should behave.
            <br />
            <br />
            Getting this step right avoids wrong prices, incorrect sales-rep assignment, and
            unexpected fulfilment or invoice status after import.
          </div>
        ),
        "Import Order Trigger":
          "Choose when a Shopify order should be brought into Orderlink (for example when paid, authorised, or placed). This decides the earliest moment Orderlink starts processing the order.",
        "Consolidate Orders":
          "Choose whether each Shopify order stays separate, or whether multiple orders can be grouped into one Orderlink sales order. Consolidation reduces order volume and helps facility processing when many small checkout orders arrive during the day.",
        "Consolidation Time":
          "If daily consolidation is enabled, set the time when Orderlink should group and create the consolidated sales orders. Use your business cut-off time so same-day orders land together.",
        "Sales Price List":
          "Select the Orderlink price list used for Shopify catalogue pricing and related product sync. Products listed to Shopify are priced from this list.",
        "Sales Rep":
          "Optionally assign a default sales representative to Shopify-origin sales orders so reporting and ownership stay consistent in Orderlink.",
        "Order Fulfilment Process":
          "Decide how far Orderlink should advance an imported Shopify order automatically (create only, allocate stock, or release picking). This aligns Shopify demand with your facility workflow.",
        "Enable Partial Fulfilment":
          "When enabled, available lines can ship even if some lines are short. Use this when customers expect partial shipments rather than waiting for full stock.",
        "Allow Backorders":
          "When enabled, Shopify orders can still be created for items with insufficient stock. Disable this if you only want to sell what is currently available.",
        "Publish Products Automatically":
          "When enabled, products listed from Orderlink are published on Shopify immediately. When disabled, they are created as drafts so you can review them in Shopify first.",
        "Revenue Account":
          "Select the Orderlink revenue account used for Shopify sales posting. Correct mapping here keeps revenue reporting accurate.",
        "Invoice Status":
          "Choose whether invoices created from Shopify sales are saved as Draft (for review) or Authorised (ready for accounting).",
      },
    },
    {
      id: "locations",
      title: "Location Mapping",
      desc: "Step 3",
      fields: {
        "Why map locations": (
          <div>
            Shopify locations and Orderlink facilities are separate systems. Mapping tells Orderlink
            which facility owns stock and fulfilment for each Shopify location.
            <br />
            <br />
            Without this mapping, inventory sync and order fulfilment cannot reliably choose the
            correct facility.
          </div>
        ),
        "Shopify Location":
          "Each left-side row is a location from your connected Shopify store. These values are fetched live from Shopify and cannot be edited here.",
        "Orderlink Facility":
          "For each Shopify location, select the Orderlink facility that should hold stock and fulfil orders for that location. Create the facility in Orderlink first if it does not exist yet.",
        "Mapping rules":
          "Map every Shopify location before inventory sync begins. Within a store, each facility can be linked to only one Shopify location, and a facility already used by another Shopify store cannot be reused.",
      },
    },
    {
      id: "tax",
      title: "Tax Mapping",
      desc: "Step 4",
      fields: {
        "Why map taxes": (
          <div>
            Shopify calculates tax using its own tax setup. Orderlink calculates and posts tax using
            Orderlink tax rates. Mapping connects each Shopify tax source to the correct Orderlink
            tax rate.
            <br />
            <br />
            This keeps imported orders, invoices, and reporting aligned with your accounting tax
            configuration. If a tax source is unmapped or mapped incorrectly, tax on Shopify sales
            can post to the wrong rate.
          </div>
        ),
        "Shopify Tax Rate":
          "Each left-side row is a tax source discovered from your Shopify store tax configuration (and related store data). These labels come from Shopify and are read-only here.",
        "Orderlink Tax Rate":
          "For each Shopify tax source, select the matching Orderlink tax rate. You can reuse the same Orderlink tax rate across multiple Shopify tax sources when that is correct for your business.",
        "Before you submit":
          "Review every row and map all required tax sources. Saved mappings are stored per store and prefilled next time you open this step. If Shopify tax setup changes (for example country or region changes), revisit this step and resubmit so mappings stay current.",
      },
    },
    {
      id: "payment",
      title: "Payment Mapping",
      desc: "Step 5",
      fields: {
        "Why map payments": (
          <div>
            Shopify records how a customer paid (for example Shopify Payments or another gateway).
            Orderlink needs to know which account code should receive that payment for accounting
            and reconciliation.
            <br />
            <br />
            Mapping payment modes prevents Shopify receipts from posting to the wrong bank or
            clearing account in Orderlink.
          </div>
        ),
        "Shopify Payment Mode":
          "Each left-side row is a payment source discovered from your Shopify store. These values are read-only and represent how payments arrive from Shopify.",
        "Orderlink Account Code":
          "For each Shopify payment mode, select the Orderlink account that should receive that payment. Reusing the same account across multiple payment modes is allowed when that matches your bookkeeping setup.",
        "Before you submit":
          "Map every payment mode shown for this store, then submit. Mappings are stored per store and reappear when you reopen this step. After payment-provider changes in Shopify, refresh this step and update mappings so settlement stays accurate.",
      },
    },
  ],
};

export const GENERAL_INSTRUCTIONS = {
  opr_account_mapping: {
    title: "Operational Account Mapping",
    /**
     * Section order for the form UI. Each field.module must match an id here.
     * Instructions popover still uses the flat `fields` list below.
     */
    modules: [
      {
        id: "purchase_inventory",
        title: "Purchase & inventory",
        description: "Receipts, bills, stock value, and purchase-side clearing accounts.",
      },
      {
        id: "sales",
        title: "Sales",
        description: "Sale invoices, dispatch COGS, tax, discounts, and write-offs.",
      },
      {
        id: "treasury",
        title: "Treasury",
        description: "Prepayments and foreign-exchange differences.",
      },
      {
        id: "production",
        title: "Production",
        description: "WIP, labour, scrap, variance, and co-manufacturing costs.",
      },
    ],
    fields: [
      {
        key: "INVENTORY_ACCOUNT",
        label: "Inventory Account",
        description: "An account used to track inventory assets.",
        module: "purchase_inventory",
      },
      {
        key: "ACCOUNT_PAYABLE",
        label: "Account Payable",
        description: "An account used to track current liabilities owed to suppliers.",
        module: "purchase_inventory",
      },
      {
        key: "BANK_ACCOUNT",
        label: "Bank Account",
        description: "An account used to track bank assets and payments.",
        module: "purchase_inventory",
      },
      {
        key: "GOODS_INVOICED_NOT_RECEIPTED",
        label: "Goods Invoiced but not Receipted",
        description:
          "An account used to track current assets related to goods invoiced but not yet receipted (GINR).",
        module: "purchase_inventory",
      },
      {
        key: "GOODS_RECEIPTED_NOT_INVOICED",
        label: "Goods Receipted but not Invoiced",
        description:
          "An account used when goods are receipted but the bill has not arrived yet (GRNI).",
        module: "purchase_inventory",
      },
      {
        key: "LANDED_COST_CLEARING",
        label: "Landed Cost Clearing",
        description:
          "A clearing account used when landed costs are capitalized into inventory on receipt.",
        module: "purchase_inventory",
      },
      {
        key: "STOCK_ADJUSTMENT_OFFSET",
        label: "Stock Adjustment Offset",
        description:
          "An expense account paired with inventory when stock adjustments change inventory value.",
        module: "purchase_inventory",
      },
      {
        key: "INVENTORY_VARIANCE",
        label: "Inventory Variance",
        description:
          "An expense account used when finance splits inventory variance from stock adjustment offset.",
        module: "purchase_inventory",
      },
      {
        key: "ACCOUNTS_RECEIVABLE",
        label: "Accounts Receivable",
        description:
          "A current asset account used to track amounts owed by customers on sale invoices.",
        module: "sales",
      },
      {
        key: "SALES_REVENUE",
        label: "Sales Revenue",
        description:
          "A revenue account used as the company default when posting sale invoice revenue journals.",
        module: "sales",
      },
      {
        key: "COST_OF_GOODS_SOLD",
        label: "Cost of Goods Sold",
        description: "An expense account used to record the cost of inventory sold or dispatched.",
        module: "sales",
      },
      {
        key: "TAX_PAYABLE",
        label: "Tax Payable",
        description:
          "A current liability account used when sale invoice tax is posted in Orderlink journals.",
        module: "sales",
      },
      {
        key: "SALES_DISCOUNT",
        label: "Sales Discount",
        description:
          "An account used when sale invoice discounts are posted separately from sales revenue.",
        module: "sales",
      },
      {
        key: "BAD_DEBT_EXPENSE",
        label: "Bad Debt Expense",
        description: "An expense account used when a sale invoice is written off.",
        module: "sales",
      },
      {
        key: "PREPAYMENT_ACCOUNT",
        label: "Prepayment Account",
        description:
          "A prepayment asset account used with bank when supplier prepayments are paid.",
        module: "treasury",
      },
      {
        key: "FX_GAIN_LOSS",
        label: "FX Gain / Loss",
        description:
          "An account used for foreign-exchange differences on multi-currency GL postings.",
        module: "treasury",
      },
      {
        key: "WIP_INVENTORY",
        label: "WIP Inventory",
        description:
          "An inventory account used when materials are consumed into manufacturing and cleared on finished goods or scrap.",
        module: "production",
      },
      {
        key: "RAW_MATERIAL_INVENTORY",
        label: "Raw Material Inventory",
        description:
          "Inventory account for raw materials when split from finished goods (else use Inventory Account).",
        module: "production",
      },
      {
        key: "FINISHED_GOODS_INVENTORY",
        label: "Finished Goods Inventory",
        description:
          "Inventory account for finished goods when split from raw materials (else use Inventory Account).",
        module: "production",
      },
      {
        key: "SCRAP_EXPENSE",
        label: "Scrap Expense",
        description: "An expense account used when production output is posted to scrap.",
        module: "production",
      },
      {
        key: "PRODUCTION_VARIANCE",
        label: "Production Variance",
        description:
          "An expense account used to clear residual WIP or production variance on close.",
        module: "production",
      },
      {
        key: "PRODUCTION_LABOUR",
        label: "Production Labour",
        description:
          "An expense account used as the company default for production labour cost journals.",
        module: "production",
      },
      {
        key: "PRODUCTION_OVERHEAD",
        label: "Production Overhead",
        description: "An overheads account used when production overhead is absorbed into WIP.",
        module: "production",
      },
      {
        key: "COMANUFACTURING_EXPENSE",
        label: "Co-Manufacturing Expense",
        description:
          "An expense account used as the company default for co-manufacturing service costs.",
        module: "production",
      },
    ],
  },
  tax_category_mapping: {
    title: "Tax Category Mapping",
    fields: [
      {
        key: "country",
        label: "Country",
        description: "The country the tax rate applies to.",
      },
      {
        key: "classification",
        label: "Product Tax Classification",
        description:
          "A grouping used to categorise products based on how they are treated for tax purposes.",
      },
      {
        key: "tax_category",
        label: "Tax Category",
        description: "Used to identify the tax category applied to a product or transaction.",
      },
    ],
  },
};

export const PRODUCT_STATUS_CHOICES = [
  { id: "Active", name: "Active" },
  { id: "On Hold", name: "On Hold" },
  { id: "In Active", name: "Inactive" },
  { id: "Not Stocked", name: "Not Stocked" },
];

export const PRODUCT_TYPE_CHOICES = [
  { id: "Finished Goods", name: "Finished Goods" },
  { id: "Raw Materials", name: "Raw Materials" },
  { id: "Consumables", name: "Consumables" },
  { id: "Packaging Material", name: "Packaging" },
  { id: "Bundle", name: "Bundle" },
  { id: "Service", name: "Service" },
  { id: "Freight", name: "Freight" },
];

export const PRODUCT_UOM_CHOICES = [
  { id: "ea", name: "Each (ea)" },
  { id: "pk", name: "Pack (pk)" },
  { id: "bx", name: "Box (bx)" },
  { id: "ctn", name: "Carton (ctn)" },
  { id: "plt", name: "Pallet (plt)" },
  { id: "kg", name: "Kilogram (kg)" },
  { id: "g", name: "Gram (g)" },
  { id: "t", name: "Tonne (t)" },
  { id: "L", name: "Litre (L)" },
  { id: "ml", name: "Millilitre (ml)" },
  { id: "m", name: "Metre (m)" },
  { id: "cm", name: "Centimetre (cm)" },
  { id: "__other__", name: "Other" },
];

export const WAREHOUSE_TYPE_CHOICES = [
  { id: "distribution_center", name: "Distribution Center / DC" },
  { id: "factory", name: "Factory / Manufacturing Plant" },
  { id: "fulfillment_center", name: "Fulfillment Center" },
  { id: "cross_dock", name: "Cross-Dock Facility" },
  { id: "sales", name: "Sales / Retail Hub" },
  { id: "3pl", name: "3PL / External Facility" },
  { id: "3pm", name: "3PM / Co-Manufacturing Plant" },
  { id: "warehouse", name: "Facility" },
];

/** Resolve facility type key to FE preset label. */
export const warehouseTypeLabel = id => {
  const found = WAREHOUSE_TYPE_CHOICES.find(item => item.id === id);
  return found?.name || id || "--";
};

export const ACQUISITION_CODE_CHOICES = [
  { id: "purchase", name: "Purchase" },
  { id: "transfer", name: "Transfer" },
];

export const COUNTRIES_CHOICES = [
  { id: "NZ", name: "New Zealand" },
  { id: "AU", name: "Australia" },
];

export const PAYMENT_TERM_TYPE_CHOICES = [
  { name: "Standard", id: "STANDARD" },
  { name: "End of Month", id: "END_OF_MONTH" },
  { name: "Fixed Day", id: "FIXED_DAY" },
];

export const BATCH_NO_CHOICES = [
  { name: "BN", id: "BN" },
  { name: "YYYYMMDD", id: "YYYYMMDD" },
];

export const TRACKING_NUMBERING_METHOD_CHOICES = [
  { id: "automatic", name: "Automatic" },
  { id: "manual", name: "Manual" },
];

export const AUTO_MANUAL_CHOICES = [
  { id: true, name: "Auto" },
  { id: false, name: "Manual" },
];

export const CURRENCY_FREQUENCY_CHOICES = [
  { id: "Daily", name: "Daily" },
  { id: "Weekly", name: "Weekly" },
  { id: "Monthly", name: "Monthly" },
];
export const INVENTORY_VALUATION_METHOD_CHOICES = [
  { id: "standard_cost", name: "Standard Cost" },
  { id: "average_cost", name: "Average Cost" },
  { id: "fifo", name: "FIFO" },
];

export const SALE_STOCK_DEPLETION_TRIGGER_CHOICES = [
  { id: "on_dispatch", name: "On dispatch (shipment in transit)" },
  { id: "on_delivery", name: "On delivery" },
  { id: "on_invoice_approval", name: "On sales invoice approval" },
];

export const PAYMENT_STATUS_SOURCE_CHOICES = [
  { id: "accounting_system", name: "Update from accounting system only" },
  { id: "orderlink", name: "Update from Orderlink only" },
];

export const PREPAYMENT_TYPE_CHOICES = [
  { id: "deposit", name: "Deposit" },
  { id: "progress_payment", name: "Progress Payment" },
  { id: "final_payment", name: "Final Payment" },
  { id: "other", name: "Other" },
];

export const PREPAYMENT_STATUS_CHOICES = [
  { id: "awaiting_authorisation", name: "Awaiting Authorisation" },
  { id: "authorised", name: "Authorised" },
  { id: "paid", name: "Paid" },
  { id: "voided", name: "Voided" },
];
export const SYNC_FREQUENCY_CHOICES = [
  { name: "2 Hours", id: "2h" },
  { name: "4 Hours", id: "4h" },
  { name: "8 Hours", id: "8h" },
  { name: "12 Hours", id: "12h" },
  { name: "Daily", id: "24h" },
];

/** Shopify store wizard Step 2 — order import lifecycle trigger. */
export const SHOPIFY_ORDER_IMPORT_TRIGGER_CHOICES = [
  { id: "paid", name: "Paid" },
  { id: "authorized", name: "Authorized" },
  { id: "placed", name: "Placed" },
];

/** Shopify store wizard Step 2 — consolidation mode. */
export const SHOPIFY_CONSOLIDATE_ORDERS_CHOICES = [
  { id: "none", name: "No Consolidation" },
  { id: "daily", name: "Daily" },
];

/** Shopify store wizard Step 2 — hourly consolidation clock (HH:00). */
export const SHOPIFY_CONSOLIDATION_TIME_CHOICES = Array.from({ length: 24 }, (_, hour) => {
  const id = `${String(hour).padStart(2, "0")}:00`;
  return { id, name: `${hour}:00` };
});

/** Shopify store wizard Step 2 — post-import fulfilment workflow. */
export const SHOPIFY_ORDER_FULFILLMENT_PROCESS_CHOICES = [
  { id: "create_sales_order_only", name: "Create Sales Order Only" },
  { id: "create_sales_order_and_allocate", name: "Create Sales Order and Allocate" },
  {
    id: "create_sales_order_and_release_picking_list",
    name: "Create Sales Order and Release Picking List",
  },
];

/** Shopify store wizard Step 2 — invoice status on create. */
export const SHOPIFY_INVOICE_STATUS_CHOICES = [
  { id: "draft", name: "Draft" },
  { id: "authorised", name: "Authorised" },
];
export const SHOPIFY_CATALOGUE_SOURCE_CHOICES = [
  { id: "orderlink", name: "Orderlink (list products, prices and stock from Orderlink)" },
  { id: "shopify", name: "Shopify (link products by SKU, show purchase orders in Shopify)" },
];
export const SHOPIFY_STOCK_SOURCE_CHOICES = [
  { id: "shopify", name: "Shopify (Orderlink reads it)" },
  { id: "orderlink", name: "Orderlink (adds receipts and adjustments)" },
];
export const PLANNING_POLICY_CHOICES = [
  { id: "safety_stock", name: "Safety Stock" },
  { id: "reorder_point_based", name: "Reorder Point Based" },
  { id: "zero_stock", name: "Zero Stock" },
  { id: "non_plan", name: "Do not Plan (Manual)" },
];
export const PLANNING_METHOD_CHOICES = [
  { id: "fixed_qty", name: "Fixed Quantity" },
  { id: "days_of_cover", name: "Days of Cover" },
];

export const REPLENISHMENT_CALCULATION_METHOD_CHOICES = [
  { id: "upto_max_stock", name: "Upto Max Stock" },
  { id: "manual", name: "Manual" },
];

export const STOCK_LINE_STATUS_CHOICES = [
  { id: "sellable", name: "Sellable" },
  { id: "on_hold", name: "On Hold" },
  { id: "rejected", name: "Rejected" },
];

/** Status IDs eligible for manual stock reclassification (matches backend rules). */
export const RECLASSIFIABLE_STATUS_IDS = new Set(
  STOCK_LINE_STATUS_CHOICES.map(choice => choice.id),
);

export const IMPACT_CHOICES = [
  { id: "qty_in", name: "Quantity Increase" },
  { id: "qty_out", name: "Quantity Decrease" },
  { id: "qty_value_in", name: "Quantity & Value Increase" },
  { id: "qty_value_out", name: "Quantity & Value Decrease" },
  { id: "qty_any", name: "Quantity (Increase/Decrease)" },
  { id: "qty_value_any", name: "Quantity & Value (Increase/Decrease)" },
];

export const LANDED_COST_TYPE_CHOICES = [
  { id: "$", name: "Dollar" },
  { id: "%", name: "Percentage" },
];

export const STOCK_TYPE_CHOICES = [
  { id: "receiving", name: "Receiving / Inbound Staging" },
  { id: "shipping", name: "Shipping / Outbound Staging" },
  { id: "picking", name: "Active Pick & Pack Zone" },
  { id: "bulk", name: "Bulk / Overstock Storage" },
  { id: "wip", name: "Work In Progress / WIP" },
  { id: "assembly", name: "Assembly Area" },
  { id: "production_floor", name: "Production Floor" },
  { id: "quarantine", name: "Quarantine / Inspection / Hold" },
  { id: "returns", name: "Returns / RMA" },
  { id: "racking", name: "High-Bay / Standard Racking" },
  { id: "cold_storage", name: "Cold Storage / Chilled / Freezer" },
  { id: "yard", name: "Yard / Outdoor Storage" },
  { id: "shed", name: "Shed / Covered Storage" },
  { id: "hazmat", name: "Hazmat / Vault" },
];

/** Alias for FE preset label map (same as STOCK_TYPE_CHOICES). */
export const STOCK_ZONE_TYPE_PRESETS = STOCK_TYPE_CHOICES;

export const stockZoneTypeLabel = id => {
  const found = STOCK_ZONE_TYPE_PRESETS.find(item => item.id === id);
  return found?.name || id || "--";
};

export const REPLENISHMENT_STATUS = [
  { name: "Pending", id: `pending` },
  { name: "Completed", id: `completed` },
  { name: "Partial", id: `partial` },
  { name: "Rejected", id: `rejected` },
];

export const SHIPMENT_STATUS_CHOICES = [
  { id: `created`, name: "Created" },
  { id: `booked`, name: "Booked" },
  { id: `in_transit`, name: "In Transit" },
  { id: `delayed`, name: "Delayed" },
  { id: `arrived`, name: "Arrived" },
  { id: "delivered", name: "Delivered" },
  { id: `completed`, name: "Completed" },
  { id: `cancelled`, name: "Cancelled" },
];

export const CUSTOMER_STATUS_CHOICES = [
  { id: "active", name: "Active" },
  { id: "on_hold", name: "On Hold" },
  { id: "prospect", name: "Prospect" },
  { id: "blacklisted", name: "Blacklisted" },
];
export const CUSTOMER_SEGMENT_STATUS_CHOICES = [
  { id: "draft", name: "Draft" },
  { id: "active", name: "Active" },
  { id: "inactive", name: "Inactive" },
];

export const CUSTOMER_TYPE_CHOICES = [
  { id: "business", name: "Business" },
  { id: "individual", name: "Individual" },
];

export const PACK_SCOPE_OPTIONS = [
  { id: "scope_purchase", name: "Purchase" },
  { id: "scope_inventory", name: "Inventory" },
  { id: "scope_sales", name: "Sales" },
  { id: "scope_production", name: "Production" },
];

// Picklist specific choice lists
export const PICKLIST_STATUS_CHOICES = [
  { id: "created", name: "Created" },
  { id: "released", name: "Released" },
  { id: "partially_picked", name: "Partially Picked" },
  { id: "fully_picked", name: "Fully Picked" },
  { id: "partially_ready_to_pack", name: "Partially Ready to Pack" },
  { id: "fully_ready_to_pack", name: "Fully Ready to Pack" },
  { id: "packed", name: "Packed" },
  { id: "cancelled", name: "Cancelled" },
];

export const PICKLIST_TYPE_CHOICES = [
  { id: "order", name: "One per order" },
  { id: "customer", name: "Group by customer" },
  { id: "batch", name: "Batch Pick" },
];

export const CUSTOMER_SUB_TYPE_CHOICES = [
  { id: "corporate", name: "Corporate" },
  { id: "dealer", name: "Dealer" },
  { id: "distributor", name: "Distributor" },
  { id: "ecommerce", name: "Ecommerce" },
  { id: "exporter", name: "Exporter" },
  { id: "internal", name: "Internal" },
  { id: "retailer", name: "Retailer" },
  { id: "sme", name: "SME" },
  { id: "stockist", name: "Stockist" },
  { id: "super_stockist", name: "Super Stockist" },
  { id: "wholesaler", name: "Wholesaler" },
];

export const MANAGE_BULK_STEPS = [
  {
    title: "Processing",
    desc: "Step 1",
  },
  {
    title: "Review",
    desc: "Step 2",
  },
  {
    title: "Complete",
    desc: "Step 3",
  },
];

const INVENTORY_BULK_MODULES = new Set(["stock_line", "stock_movement", "stock_reclassification"]);

/** Bulk exit/success routes: inventory bulk → details grid; master data → /master/{listUrl}. */
export function getBulkListPath(module, listUrl) {
  if (INVENTORY_BULK_MODULES.has(module)) {
    return "/inventory/details";
  }
  if (!listUrl) return "/";
  const normalized = String(listUrl).replace(/^\/+/, "").replace(/\/+$/, "");
  if (normalized.startsWith("inventory/")) return `/${normalized}`;
  return `/master/${normalized}`;
}

export const BULK_OPERATION_CREATE_CONFIG = {
  customer: {
    listUrl: "customers",
    modalTitle: "Create Customer",
    singleCreatePageUrl: "customer/create",
    verboseName: "Customer",
    verboseNamePlural: "Customers",
  },
  forecast: {
    listUrl: "forecasts",
    modalTitle: "Create Forecast",
    singleCreatePageUrl: "forecast/create",
    verboseName: "Forecast",
    verboseNamePlural: "Forecasts",
  },
  pack: {
    listUrl: "packs",
    modalTitle: "Create Pack",
    singleCreatePageUrl: "pack/create",
    verboseName: "Pack",
    verboseNamePlural: "Packs",
  },
  product: {
    listUrl: "products",
    modalTitle: "Create Products",
    singleCreatePageUrl: "product/create",
    verboseName: "Product",
    verboseNamePlural: "Products",
  },
  product_alias: {
    listUrl: "product_aliases",
    modalTitle: "Create Product Alias",
    singleCreatePageUrl: "product_alias/create",
    verboseName: "Product Alias",
    verboseNamePlural: "Product Aliases",
  },
  product_category: {
    listUrl: "product_categories",
    modalTitle: "Create Product Category",
    singleCreatePageUrl: "product_category/create",
    verboseName: "Product Category",
    verboseNamePlural: "Product Categories",
  },
  product_plan: {
    listUrl: "product_plans",
    modalTitle: "Create Product Plan",
    singleCreatePageUrl: "product_plan/create",
    verboseName: "Product Plan",
    verboseNamePlural: "Product Plans",
  },
  product_tag: {
    listUrl: "product_tags",
    modalTitle: "Create Product Tag",
    singleCreatePageUrl: "product_tag/create",
    verboseName: "Product Tag",
    verboseNamePlural: "Product Tags",
  },
  customer_tag: {
    listUrl: "customer_tags",
    modalTitle: "Create Customer Tag",
    singleCreatePageUrl: "customer_tag/create",
    verboseName: "Customer Tag",
    verboseNamePlural: "Customer Tags",
  },
  customer_segment: {
    listUrl: "customer_segments",
    modalTitle: "Create Customer Segment",
    singleCreatePageUrl: "customer_segment/create",
    verboseName: "Customer Segment",
    verboseNamePlural: "Customer Segments",
  },
  stock_location: {
    listUrl: "stock_locations",
    modalTitle: "Create Stock Location",
    singleCreatePageUrl: "stock_location/create",
    verboseName: "Stock Location",
    verboseNamePlural: "Stock Locations",
  },
  stock_zone: {
    listUrl: "stock_zones",
    modalTitle: "Create Stock Zone",
    singleCreatePageUrl: "stock_zone/create",
    verboseName: "Stock Zone",
    verboseNamePlural: "Stock Zones",
  },
  stock_line: {
    listUrl: "inventory/details",
    modalTitle: "Create Initial Stock",
    singleCreatePageUrl: "stock_line/create",
    verboseName: "Stock Line",
    verboseNamePlural: "Stock Lines",
  },
  stock_movement: {
    listUrl: "inventory/details",
    modalTitle: "Bulk Stock Movement",
    singleCreatePageUrl: "detail/stock_movement",
    verboseName: "Stock Movement",
    verboseNamePlural: "Stock Movements",
    updateModalTitle: "Stock Movement",
    updateSingleActionTitle: "Create Movement",
    updateSingleDescription: "Move one product at a time.",
    updateMultipleDescription: "Move multiple product at once.",
  },
  stock_reclassification: {
    listUrl: "inventory/details",
    modalTitle: "Bulk Stock Reclassify",
    singleCreatePageUrl: "detail/stock_reclassification",
    verboseName: "Stock Reclassification",
    verboseNamePlural: "Stock Reclassifications",
    updateModalTitle: "Stock Reclassification",
    updateSingleActionTitle: "Create Reclassification",
    updateSingleDescription: "Reclassify one product at a time.",
    updateMultipleDescription: "Reclassify multiple products at once.",
  },
  supplier: {
    listUrl: "suppliers",
    modalTitle: "Create Supplier",
    singleCreatePageUrl: "supplier/create",
    verboseName: "Supplier",
    verboseNamePlural: "Suppliers",
  },
  warehouse: {
    listUrl: "warehouses",
    modalTitle: "Create Facility",
    singleCreatePageUrl: "warehouse/create",
    verboseName: "Facility",
    verboseNamePlural: "Facilities",
  },
  warehouse_costing: {
    listUrl: "warehouse_costings",
    modalTitle: "Create Facility Costing",
    singleCreatePageUrl: "warehouse_costing/create",
    verboseName: "Facility Costing",
    verboseNamePlural: "Facility Costings",
  },
  transaction_reason: {
    listUrl: "transaction_reasons",
    modalTitle: "Create Stock Adjustment Reason",
    singleCreatePageUrl: "transaction_reason/create",
    verboseName: "Stock Adjustment Reason",
    verboseNamePlural: "Stock Adjustment Reasons",
  },
  standard_costing: {
    listUrl: "standard_costings",
    modalTitle: "Create Standard Cost",
    singleCreatePageUrl: "standard_costing/create",
    verboseName: "Standard Cost",
    verboseNamePlural: "Standard Costs",
  },

  charts_of_account: {
    listUrl: "charts_of_accounts",
    modalTitle: "Create Account",
    singleCreatePageUrl: "charts_of_account/create",
    verboseName: "Account",
    verboseNamePlural: "Accounts",
  },
  payment_term: {
    listUrl: "payment_terms",
    modalTitle: "Create Payment Term",
    singleCreatePageUrl: "payment_term/create",
    verboseName: "Payment Term",
    verboseNamePlural: "Payment Terms",
  },
  charge_type: {
    listUrl: "charge-type",
    modalTitle: "Create Charge Type",
    singleCreatePageUrl: "charge-type/create",
    verboseName: "Charge Type",
    verboseNamePlural: "Charge Types",
  },
  tax_rate: {
    listUrl: "tax_rates",
    modalTitle: "Create Tax Rate",
    singleCreatePageUrl: "tax_rate/create",
    verboseName: "Tax Rate",
    verboseNamePlural: "Tax Rates",
  },
  tax_category: {
    listUrl: "tax_categories",
    modalTitle: "Create Tax Category",
    singleCreatePageUrl: "tax_category/create",
    verboseName: "Tax Category",
    verboseNamePlural: "Tax Categories",
  },
  sales_rep: {
    listUrl: "sales_reps",
    modalTitle: "Create Sales Rep",
    singleCreatePageUrl: "sales_rep/create",
    verboseName: "Sales Rep",
    verboseNamePlural: "Sales Reps",
  },
  product_tax_classification: {
    listUrl: "product_tax_classifications",
    modalTitle: "Create Product Tax Classification",
    singleCreatePageUrl: "product_tax_classification/create",
    verboseName: "Product Tax Classification",
    verboseNamePlural: "Product Tax Classifications",
  },
  unit_of_measure: {
    listUrl: "unit_of_measures",
    modalTitle: "Create Unit of Measure",
    singleCreatePageUrl: "unit_of_measure/create",
    verboseName: "Unit of Measure",
    verboseNamePlural: "Units of Measure",
  },
  equipment_type: {
    listUrl: "equipment_types",
    modalTitle: "Create Equipment Type",
    singleCreatePageUrl: "equipment_type/create",
    verboseName: "Equipment Type",
    verboseNamePlural: "Equipment Type",
  },
  equipment: {
    listUrl: "equipments",
    modalTitle: "Create Equipment",
    singleCreatePageUrl: "equipment/create",
    verboseName: "Equipment",
    verboseNamePlural: "Equipment",
  },
  site: {
    listUrl: "sites",
    modalTitle: "Create Site",
    singleCreatePageUrl: "site/create",
    verboseName: "Site",
    verboseNamePlural: "Sites",
  },
  work_center: {
    listUrl: "work_centers",
    modalTitle: "Create Work Centre",
    singleCreatePageUrl: "work_center/create",
    verboseName: "Work Centre",
    verboseNamePlural: "Work Centres",
  },
  people: {
    listUrl: "peoples",
    modalTitle: "Create People",
    singleCreatePageUrl: "people/create",
    verboseName: "Person",
    verboseNamePlural: "People",
  },
};

export const ICON_COMPONENT_MAP = {
  download: <Download />,
  plus: <Plus />,
};

export const CHANNEL_CHOICES = [
  { id: "ecommerce", name: "E-Commerce" },
  { id: "b2b_portal", name: "B2B Portal" },
  { id: "shopify", name: "Shopify" },
  { id: "amazon", name: "Amazon" },
  { id: "retail", name: "Retail" },
];

export const PRICELIST_STATUS_CHOICES = [
  { id: "draft", name: "Draft" },
  { id: "published", name: "Published" },
];

export const QUOTATION_STATUS_CHOICES = [
  { name: "Draft", id: `draft` },
  { name: "Sent", id: `sent` },
  { name: "Viewed", id: `viewed` },
  { name: "Edited", id: `edited` },
  { name: "Accepted", id: `accepted` },
  { name: "Rejected", id: `rejected` },
  { name: "Cancelled", id: `cancelled` },
  { name: "Changes Requested", id: `changes_requested` },
  { name: "Expired", id: `expired` },
  { name: "Converted", id: `converted` },
];

export const SHIPMENT_LEG_STATUS_CHOICES = [
  { id: "created", name: "Created" },
  { id: "departed", name: "Departed" },
  { id: "in_transit", name: "In Transit" },
  { id: "arrived", name: "Arrived" },
  { id: "completed", name: "Completed" },
];

export const LEG_TYPE_CHOICES = [
  { id: "PICKUP", name: "Pickup" },
  { id: "LINEHAUL", name: "Linehaul" },
  { id: "DELIVERY", name: "Delivery" },
];

export const TRANSPORT_MODE_CHOICES = [
  { id: "ROAD", name: "Road" },
  { id: "SEA", name: "Sea" },
  { id: "AIR", name: "Air" },
  { id: "RAIL", name: "Rail" },
];

export const PRICE_LOGIC_CHOICES = [
  { id: "markup_pct", name: "Markup %" },
  { id: "markup_amt", name: "Markup Amount" },
  { id: "discount_pct", name: "Discount %" },
  { id: "discount_amt", name: "Discount Amount" },
  { id: "fixed_price", name: "Fixed Price" },
  { id: "formula", name: "Formula" },
];

export const PRICE_BASE_CHOICES = [
  { id: "average_cost", name: "Average Cost" },
  { id: "standard_cost", name: "Standard Cost" },
  { id: "fifo", name: "FIFO" },
];

export const EXTRA_FEE_DIRECTION_CHOICES = [
  { id: "increase", name: "Increase" },
  { id: "decrease", name: "Decrease" },
];

export const PROMO_STATUS_CHOICES = [
  { id: "active", name: "Active" },
  { id: "inactive", name: "Inactive" },
  { id: "scheduled", name: "Scheduled" },
  { id: "expired", name: "Expired" },
];

export const DELIVERY_STATUS_CHOICES = [
  { id: "created", name: "Created" },
  { id: "booked", name: "Booked" },
  { id: "cancelled", name: "Cancelled" },
  { id: "ready_for_dispatch", name: "Ready For Dispatch" },
  { id: "in_transit", name: "In Transit" },
  { id: "delivered", name: "Delivered" },
];

export const SERVICE_LEVEL_CHOICES = [
  { id: "standard", name: "Standard" },
  { id: "express", name: "Express" },
];
export const BOOLEAN_CHOICES = [
  { id: true, name: "Yes" },
  { id: false, name: "No" },
];

export const FREIGHT_TYPE_CHOICES = [
  { id: "door_to_door", name: "Door To Door" },
  { id: "door_to_port", name: "Door To Port" },
  { id: "port_to_door", name: "Port To Door" },
  { id: "port_to_port", name: "Port To Port" },
];

export const PORTAL_INVITATION_STATUS_CHOICES = [
  { value: "pending", label: "Pending" },
  { value: "accepted", label: "Accepted" },
  { value: "expired", label: "Expired" },
];

export const MANUFACTURING_ORDER_STATUS_CHOICES = [
  { id: "draft", name: "Draft" },
  { id: "planned", name: "Planned" },
  { id: "released", name: "Released" },
];

export const CO_MANUFACTURING_ORDER_STATUS_CHOICES = [
  { id: "draft", name: "Draft" },
  { id: "created", name: "Created" },
];

export const INCOTERM_CHOICES = [
  { id: "exw", name: "EXW" },
  { id: "fob", name: "FOB" },
  { id: "fas", name: "FAS" },
  { id: "fca", name: "FCA" },
  { id: "cpt", name: "CPT" },
  { id: "cfr", name: "CFR" },
  { id: "cif", name: "CIF" },
  { id: "cip", name: "CIP" },
  { id: "dat", name: "DAT" },
  { id: "dap", name: "DAP" },
  { id: "ddp", name: "DDP" },
  { id: "dpu", name: "DPU" },
];

// function for {label, value} to change to {id, name}
export const convertToIdName = choices => {
  return choices.map(choice => ({ id: choice.value, name: choice.label }));
};

// function for {id, name} to change to {label, value}
export const convertToLabelValue = choices => {
  return choices.map(choice => ({ label: choice.name, value: choice.id }));
};
